import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AccountProductType } from '@models/account.model'
import { AccountService } from '@services/account.service'

export const signerProductGuard: CanActivateFn = () => {
	const accountService = inject(AccountService)
	const router = inject(Router)

	if (!accountService.isSinger) {
		return router.createUrlTree(['/dashboard'])
	}

	const currentProductType = accountService.currentProduct?.type

	if (currentProductType !== AccountProductType.SIG) {
		accountService.changeProduct(AccountProductType.SIG)
	}

	return true
}
